import { faHexagonExclamation } from '@fortawesome/pro-solid-svg-icons';

import { Alert, Button } from '@growtherapy/sprout-ui';

type CSSRSPromptAlertProps = {
  onClose: () => void;
  patientName: string;
  onAdministerCSSRS: () => void;
  heading: string;
  body: string;
  callToAction: string;
  className?: string;
};

export function CSSRSPromptAlert({
  onClose,
  patientName,
  onAdministerCSSRS,
  heading,
  body,
  callToAction,
  className,
}: CSSRSPromptAlertProps) {
  return (
    <Alert
      actions={
        <Button className='whitespace-nowrap' use='secondary' onClick={onAdministerCSSRS}>
          {callToAction}
        </Button>
      }
      className={className}
      heading={heading}
      headingAs='h3'
      icon={faHexagonExclamation}
      use='error'
      onClose={onClose}
    >
      <span className='fs-exclude data-dd-privacy'>{patientName || 'Your client'}</span> {body}
    </Alert>
  );
}
